function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { LifecycleEvent } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../../../core-video-internal';
import { PlaybackType } from '../../../core/player/playout-data';
import { TestingOverrides } from '../../../core/services/testing-overrides';
import { InternalSessionState } from '../../../core/session-controller/internal-session-state';
import { sdkLogger } from '../../../logger';
import { ContentSegments } from '../../../utils/content-segments';
import { JsonUtils } from '../../../utils/json-utils';
import { checkIsManifestVodType } from '../../../utils/playback-type';
import { NielsenTrackingType } from '../../addon-playout-data';
import { ReportingAddon } from '../reporting-addon';
import { NielsenDefaultEnabledPlaybackTypes } from './nielsen-types';
import { NielsenCloudApiClient, NielsenEventType } from './nielson-api-client/nielsen-cloud-api-client';
import { getAdBreakForAd } from '../../../utils/ad-break-utils';
var Logger = sdkLogger.withContext('NielsenAddon');
export var TRACKING_UPDATE_INTERVAL_MS = 10000;
var MonitoredStates = [
    InternalSessionState.Finished,
    InternalSessionState.Rebuffering,
    InternalSessionState.PlayerLoading,
    InternalSessionState.Paused,
    InternalSessionState.Stopped,
    InternalSessionState.Playing
];
export var NielsenAddon = /*#__PURE__*/ function(ReportingAddon) {
    "use strict";
    _inherits(NielsenAddon, ReportingAddon);
    function NielsenAddon(config, sessionItem, session, reportingData, metaAdapter, postDestroy) {
        _class_call_check(this, NielsenAddon);
        var _this;
        _this = _call_super(this, NielsenAddon), _define_property(_this, "config", void 0), _define_property(_this, "sessionItem", void 0), _define_property(_this, "session", void 0), _define_property(_this, "reportingData", void 0), _define_property(_this, "metaAdapter", void 0), _define_property(_this, "postDestroy", void 0), _define_property(_this, "name", void 0), _define_property(_this, "adBreaks", void 0), _define_property(_this, "chapterNumber", void 0), _define_property(_this, "contentSegments", void 0), _define_property(_this, "seekableRange", void 0), _define_property(_this, "nielsenApiClient", void 0), _define_property(_this, "playoutData", void 0), _define_property(_this, "currentAdvert", void 0), _define_property(_this, "currentState", void 0), _define_property(_this, "currentPosition", void 0), _define_property(_this, "currentMainPosition", void 0), _define_property(_this, "intervalRef", void 0), _define_property(_this, "adBreaksReported", void 0), _define_property(_this, "isSessionRetrying", void 0), _define_property(_this, "track", void 0), _this.config = config, _this.sessionItem = sessionItem, _this.session = session, _this.reportingData = reportingData, _this.metaAdapter = metaAdapter, _this.postDestroy = postDestroy, _this.name = 'Nielsen', _this.adBreaks = null, _this.chapterNumber = null, _this.contentSegments = [
            {
                startPosition: 0,
                endPosition: Infinity
            }
        ], _this.nielsenApiClient = null, _this.playoutData = null, _this.currentAdvert = null, _this.adBreaksReported = false, _this.isSessionRetrying = false, _this.track = function(nielsenEventType) {
            // While a SessionRetry is happening we should not emit any playhead events
            if (_this.isSessionRetrying) {
                return;
            }
            if (_this.currentPosition === undefined) {
                Logger.verbose('Initial playhead position not yet received, preventing track event.');
                return;
            }
            if (_this.currentAdvert && _this.adBreaks) {
                var adBreak = getAdBreakForAd(_this.currentAdvert, _this.adBreaks);
                if (adBreak) {
                    var _this_nielsenApiClient;
                    (_this_nielsenApiClient = _this.nielsenApiClient) === null || _this_nielsenApiClient === void 0 ? void 0 : _this_nielsenApiClient.trackAdvert(_this.currentAdvert, adBreak, Math.round(_this.currentPosition));
                }
            } else {
                var _this_nielsenApiClient1;
                var type = (nielsenEventType !== null && nielsenEventType !== void 0 ? nielsenEventType : _this.currentState === InternalSessionState.Finished) ? NielsenEventType.Complete : NielsenEventType.Playhead;
                (_this_nielsenApiClient1 = _this.nielsenApiClient) === null || _this_nielsenApiClient1 === void 0 ? void 0 : _this_nielsenApiClient1.trackContent(type, Math.round(_this.currentPosition));
            }
        };
        _this.listenToPlayoutDataEvents();
        return _this;
    }
    _create_class(NielsenAddon, [
        {
            key: "destroy",
            value: function destroy() {
                var _this_nielsenApiClient, _this_postDestroy, _this;
                this.adBreaks = null;
                this.contentSegments = undefined;
                this.seekableRange = undefined;
                (_this_nielsenApiClient = this.nielsenApiClient) === null || _this_nielsenApiClient === void 0 ? void 0 : _this_nielsenApiClient.destroy();
                this.nielsenApiClient = null;
                this.playoutData = null;
                this.currentAdvert = null;
                this.adBreaksReported = false;
                this.stopTrackingUpdates();
                CoreVideoInternal.lifecycle.off(LifecycleEvent.Resume, this.track);
                CoreVideoInternal.lifecycle.off(LifecycleEvent.Suspend, this.track);
                (_this_postDestroy = (_this = this).postDestroy) === null || _this_postDestroy === void 0 ? void 0 : _this_postDestroy.call(_this);
            }
        },
        {
            key: "listenToEvents",
            value: function listenToEvents() {
                this.listenForAdBreakDataEvents();
                this.listenToLifeCycleEvents();
                this.listenToAdvertEvents();
                this.listenToPlaybackTimelineUpdates();
                this.listenToStateChanges();
                this.listenToSessionRetryEvents();
                this.listenToSeekEvents();
                this.listenToUpdateMetadataEvents();
            }
        },
        {
            key: "listenToLifeCycleEvents",
            value: function listenToLifeCycleEvents() {
                CoreVideoInternal.lifecycle.on(LifecycleEvent.Resume, this.track);
                CoreVideoInternal.lifecycle.on(LifecycleEvent.Suspend, this.track);
            }
        },
        {
            key: "listenForAdBreakDataEvents",
            value: function listenForAdBreakDataEvents() {
                var _this = this;
                this.session.onAdBreakDataReceived(function(adBreaks) {
                    _this.adBreaks = adBreaks;
                });
            }
        },
        {
            key: "reportAdBreaks",
            value: function reportAdBreaks() {
                if (this.adBreaks && this.playoutData && this.seekableRange) {
                    var mainContentDuration = checkIsManifestVodType(this.playoutData.type) ? this.seekableRange.end : 0;
                    this.contentSegments = ContentSegments.fromAdBreaks(mainContentDuration, this.adBreaks);
                    this.adBreaksReported = true;
                }
            }
        },
        {
            key: "listenToAdvertEvents",
            value: function listenToAdvertEvents() {
                var _this = this;
                this.session.onAdBreakStarted(function() {
                    _this.track();
                });
                this.session.onAdBreakFinished(function() {
                    _this.track();
                    _this.currentAdvert = null;
                });
                // work around for a bug where onAdFinished is never called.
                this.session.onAdStarted(function(ad) {
                    _this.currentAdvert = ad;
                    _this.currentPosition = 0;
                    _this.track();
                });
                this.session.onAdFinished(function(ad) {
                    var _this_playoutData;
                    if (((_this_playoutData = _this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.type) === PlaybackType.VOD) {
                        var _this_currentAdvert;
                        var _this_currentAdvert_expectedDuration;
                        _this.currentPosition = (_this_currentAdvert_expectedDuration = (_this_currentAdvert = _this.currentAdvert) === null || _this_currentAdvert === void 0 ? void 0 : _this_currentAdvert.expectedDuration) !== null && _this_currentAdvert_expectedDuration !== void 0 ? _this_currentAdvert_expectedDuration : _this.currentPosition;
                    }
                    _this.track();
                    _this.currentPosition = _this.currentMainPosition;
                    _this.currentAdvert = null;
                });
            }
        },
        {
            key: "listenToSessionRetryEvents",
            value: function listenToSessionRetryEvents() {
                var _this = this;
                this.session.onSessionRetryStarted(function() {
                    _this.isSessionRetrying = true;
                });
                this.session.onSessionRetryEnded(function() {
                    _this.isSessionRetrying = false;
                });
            }
        },
        {
            key: "listenToUpdateMetadataEvents",
            value: function listenToUpdateMetadataEvents() {
                var _this = this;
                this.session.onAssetMetadataUpdated(function(assetMetadata) {
                    _this.track();
                    // final playhead update for outgoing program
                    _this.track(NielsenEventType.Complete);
                    Logger.info("Updating asset metadata. New metadata: ".concat(JsonUtils.stringify(assetMetadata)));
                    _this.reportingData.assetMetadata = _object_spread({}, _this.reportingData.assetMetadata, assetMetadata);
                    _this.track();
                });
            }
        },
        {
            key: "listenToSeekEvents",
            value: // first playhead update for new program
            function listenToSeekEvents() {
                var _this = this;
                // only report seek events for VOD assets
                var isManifestVodType = checkIsManifestVodType(this.playoutData.type);
                this.session.onSeekStarted(function() {
                    if (isManifestVodType) {
                        _this.trackSeekStartEvent();
                    }
                });
                this.session.onSeekEnded(function() {
                    if (isManifestVodType) {
                        _this.trackSeekEndEvent();
                    }
                });
            }
        },
        {
            key: "listenToPlayoutDataEvents",
            value: function listenToPlayoutDataEvents() {
                var _this = this;
                this.session.onPlayoutDataReceived(function(playoutData) {
                    if (_this.playoutData && _this.playoutData.type !== PlaybackType.Advert) {
                        return;
                    }
                    _this.playoutData = playoutData;
                    var _this_config = _this.config, _this_config_enabledPlaybackTypes = _this_config.enabledPlaybackTypes, enabledPlaybackTypes = _this_config_enabledPlaybackTypes === void 0 ? NielsenDefaultEnabledPlaybackTypes : _this_config_enabledPlaybackTypes;
                    if (!_this.checkTrackingTypeIsDcr(playoutData) || !enabledPlaybackTypes.includes(_this.sessionItem.type)) {
                        _this.destroy();
                        return;
                    }
                    _this.nielsenApiClient = _this.createNielsenApiClient();
                    _this.listenToEvents();
                    _this.startTrackingUpdates();
                });
            }
        },
        {
            key: "checkTrackingTypeIsDcr",
            value: function checkTrackingTypeIsDcr(playoutData) {
                var _playoutData_nielsen, _playoutData_nielsen1;
                if (TestingOverrides.nielsenDtvrOverride) {
                    return TestingOverrides.nielsenDtvrOverride === 'DCR';
                }
                return ((_playoutData_nielsen = playoutData.nielsen) === null || _playoutData_nielsen === void 0 ? void 0 : _playoutData_nielsen.nielsenTrackingType) === NielsenTrackingType.DCR || ((_playoutData_nielsen1 = playoutData.nielsen) === null || _playoutData_nielsen1 === void 0 ? void 0 : _playoutData_nielsen1.nielsenTrackingType) === undefined;
            }
        },
        {
            key: "listenToPlaybackTimelineUpdates",
            value: function listenToPlaybackTimelineUpdates() {
                var _this = this;
                this.session.onPlaybackTimelineUpdated(function(param) {
                    var seekableRange = param.seekableRange, position = param.position;
                    _this.seekableRange = seekableRange;
                    _this.currentMainPosition = position;
                    // Ad Playing
                    if (_this.currentAdvert != null) {
                        return;
                    }
                    if (!_this.adBreaksReported) {
                        _this.reportAdBreaks();
                    }
                    _this.currentPosition = position;
                    if (!_this.contentSegments) {
                        return;
                    }
                    var currentSegmentPosition = ContentSegments.findSegment(_this.contentSegments, position);
                    if (currentSegmentPosition) {
                        if (!_this.chapterNumber) {
                            _this.chapterNumber = currentSegmentPosition;
                            _this.trackStartChapterEvent();
                            return;
                        }
                        if (currentSegmentPosition !== _this.chapterNumber) {
                            _this.trackEndChapterEvent();
                            _this.chapterNumber = currentSegmentPosition;
                            _this.trackStartChapterEvent();
                            return;
                        }
                    }
                });
                this.session.onAdPositionChanged(function(param) {
                    var adPosition = param.adPosition;
                    if (_this.currentAdvert) {
                        _this.currentPosition = adPosition;
                    }
                });
            }
        },
        {
            key: "listenToStateChanges",
            value: function listenToStateChanges() {
                var _this = this;
                this.session.onStateChanged(function(state) {
                    if (!MonitoredStates.includes(state) || _this.currentAdvert && state === InternalSessionState.Finished) {
                        return;
                    }
                    if (state === InternalSessionState.Playing) {
                        var previousStates = [
                            InternalSessionState.Paused,
                            InternalSessionState.Rebuffering
                        ];
                        if (previousStates.includes(_this.currentState)) {
                            _this.track();
                        }
                        _this.currentState = state;
                    } else {
                        _this.currentState = state;
                        _this.track();
                    }
                });
            }
        },
        {
            key: "createNielsenApiClient",
            value: function createNielsenApiClient() {
                var _this = this;
                var deviceType = CoreVideoInternal.deviceType;
                var metaAdapter = this.metaAdapter;
                if (NielsenCloudApiClient.canUse(deviceType, metaAdapter)) {
                    Logger.info("A NielsenApiClient has been found for ".concat(deviceType));
                    Logger.info('Initialising NielsenApiClient');
                    var contentData = {
                        playoutData: this.playoutData,
                        checkContentHasAds: function() {
                            return Array.isArray(_this.adBreaks) && _this.adBreaks.length > 0;
                        }
                    };
                    return new NielsenCloudApiClient(this.config, contentData, this.reportingData, metaAdapter);
                } else {
                    Logger.info("No NielsenApiClient has been found for ".concat(deviceType));
                    return null;
                }
            }
        },
        {
            key: "trackSeekStartEvent",
            value: function trackSeekStartEvent() {
                this.track();
            }
        },
        {
            key: "trackSeekEndEvent",
            value: function trackSeekEndEvent() {
                this.track();
            }
        },
        {
            key: "trackStartChapterEvent",
            value: function trackStartChapterEvent() {
                this.track();
            }
        },
        {
            key: "trackEndChapterEvent",
            value: function trackEndChapterEvent() {
                this.track();
            }
        },
        {
            key: "startTrackingUpdates",
            value: function startTrackingUpdates() {
                var _this = this;
                this.intervalRef = setInterval(function() {
                    if (_this.currentState === InternalSessionState.Playing) {
                        _this.track();
                    }
                }, TRACKING_UPDATE_INTERVAL_MS);
            }
        },
        {
            key: "stopTrackingUpdates",
            value: function stopTrackingUpdates() {
                clearInterval(this.intervalRef);
            }
        }
    ]);
    return NielsenAddon;
}(ReportingAddon);
_define_property(NielsenAddon, "requiresUserConsentToBeUsed", true);

//# sourceMappingURL=nielsen-addon.js.map